// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__rJXQb","header":"MessagesList_header__28t8e","chat":"MessagesList_chat__12IFW"};